var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "-2 -9 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "connection [#1106]") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-140.000000, -3325.000000)",
    fill: "#A3AED0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,3171 C98.897,3171 98,3170.103 98,3169 C98,3167.897 98.897,3167 100,3167 C101.103,3167 102,3167.897 102,3169 C102,3170.103 101.103,3171 100,3171 M94,3171 C92.897,3171 92,3170.103 92,3169 C92,3167.897 92.897,3167 94,3167 C95.103,3167 96,3167.897 96,3169 C96,3170.103 95.103,3171 94,3171 M88,3171 C86.897,3171 86,3170.103 86,3169 C86,3167.897 86.897,3167 88,3167 C89.103,3167 90,3167.897 90,3169 C90,3170.103 89.103,3171 88,3171 M100,3165 C98.798,3165 97.733,3165.541 97,3166.38 C96.267,3165.541 95.202,3165 94,3165 C92.798,3165 91.733,3165.541 91,3166.38 C90.267,3165.541 89.202,3165 88,3165 C85.791,3165 84,3166.791 84,3169 C84,3171.209 85.791,3173 88,3173 C89.202,3173 90.267,3172.459 91,3171.62 C91.733,3172.459 92.798,3173 94,3173 C95.202,3173 96.267,3172.459 97,3171.62 C97.733,3172.459 98.798,3173 100,3173 C102.209,3173 104,3171.209 104,3169 C104,3166.791 102.209,3165 100,3165",
    id: "connection-[#1106]"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.0e599c91f38fdc4fb2dd12c5d6271f53.svg";
export { ForwardRef as ReactComponent };